import React from 'react';

/**
 * BrandMark — the stacked CONNECT / TO / LOVE wordmark in GT Pressura Mono
 * matching connecttolove.com on Wix. Available in two sizes:
 *   - 'hero' (Entry page, dominant)
 *   - 'compact' (Buy / Welcome / Redeem header)
 *
 * The mark itself is decorative; ariaLabel is set on the wrapper so screen
 * readers hear "Connect to Love" rather than three disconnected words.
 */
export default function BrandMark({ size = 'hero', as: Tag = 'div', className = '' }) {
  const isHero = size === 'hero';

  // Type scale — clamp() so every screen lands somewhere reasonable.
  // Hero hierarchy mirrors the Wix masthead exactly: CONNECT 82px / TO 30px / LOVE 222px (desktop).
  const connectSize = isHero
    ? 'clamp(2.25rem, 8vw, 5rem)'    // ~36px → 82px
    : 'clamp(1.125rem, 3vw, 1.625rem)';
  const toSize = isHero
    ? 'clamp(0.95rem, 2.4vw, 1.65rem)' // ~15px → 26px
    : 'clamp(0.6rem, 1.4vw, 0.85rem)';
  const loveSize = isHero
    ? 'clamp(5rem, 22vw, 13.875rem)'   // ~80px → 222px
    : 'clamp(2.25rem, 6vw, 3.5rem)';

  // Tight line-height keeps the giant LOVE from creating awkward whitespace.
  const lineHeight = isHero ? 0.95 : 0.95;

  return (
    <Tag
      className={`font-pressura text-[#000000] text-center select-none ${className}`}
      aria-label="Connect to Love"
      data-testid="brand-mark"
    >
      <div
        style={{
          fontSize: connectSize,
          fontWeight: 700,
          lineHeight,
          letterSpacing: '-0.01em',
        }}
        data-testid="brand-mark-connect"
      >
        CONNECT
      </div>
      <div
        style={{
          fontSize: toSize,
          fontWeight: 700,
          lineHeight: 1.4,
          letterSpacing: '0',
          marginTop: isHero ? '0.4em' : '0.25em',
          marginBottom: isHero ? '0.15em' : '0.1em',
        }}
        data-testid="brand-mark-to"
      >
        TO
      </div>
      <div
        style={{
          fontSize: loveSize,
          fontWeight: 700,
          lineHeight,
          letterSpacing: '-0.02em',
        }}
        data-testid="brand-mark-love"
      >
        LOVE
      </div>
    </Tag>
  );
}
